// All the filters on the claims work in the same way - so we have a common method for testing
// We must pass in;
//  1. Caller's email address
//  2. The data owner's email address (all data should have an owner!)
//  2. The filter from the claim (this will contain the Eeail address of the data owner -for instance an endorsement or employee profile)
//
// Filter can be:
//   * - all items pass
//   ?empty? - no items pass
//   [self] - if the caller matches the data owner email
//    TODO: An array of emails???

export const AuthFilterAll = "*";
export const AuthFilterOwn = "[own]";

export class AuthFilter {
  filter?: string | string[];
  ownerEmail?: string;

  constructor(filter?: string | string[], ownerEmail?: string) {
    this.filter = filter;
    this.ownerEmail = ownerEmail;
  }

  public test(testEmail: string): boolean {
    if (this.filter === AuthFilterAll) {
      return true;
    } else if (this.filter === AuthFilterOwn) {
      if (this.ownerEmail === testEmail) {
        return true;
      }
    } else {
      //TODO: Is there a list of email addresses?
    }

    return false;
  }
}
